//export const BASE_URL = 'http://localhost:1337';
export const BASE_URL = 'https://api.v1.verifieddna.com';
export const BASE_IMAGES = 'https://api.v1.verifieddna.com';
